module.exports = __webpack_public_path__ + "static/media/good-game-shelf-logo.b0b5bb85.png";